// export { wrapRootElement } from "./wrap-with-i18n";
import React, { Fragment } from "react"
import { Script } from "gatsby";
import "./src/style.css";
import "typeface-lato";

// Add Google Fonts
export const onClientEntry = () => {
  // Load Google Fonts
  const link = document.createElement('link');
  link.href = 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap';
  link.rel = 'stylesheet';
  document.head.appendChild(link);
};

